import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { NewWidgetDialogBaseDirective } from '@fi-shared/fi-report-widget/new-report-widget-dialog/new-widget-dialog-base';
import { IOnboardingReportContainer, IOnboardingReportWidget } from '../../fi-onboarding-report';
import { FiOnboardingReportDataService } from '../../services/fi-onboarding-report-data.service';
import { FiOnboardingReportType } from '../../fi-onboarding-report-enums';
import { isNullOrUndefined } from '@fi-app/shared/utils/is-null-or-undefined';

@Component({
    selector: 'fi-onboarding-report-new-widget-dialog',
    templateUrl: './fi-onboarding-report-new-widget-dialog.component.html',
    styleUrls: ['./fi-onboarding-report-new-widget-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-report-new-widget-dialog' },
    standalone: false,
})
export class FiOnboardingReportNewWidgetDialogComponent extends NewWidgetDialogBaseDirective<
    FiOnboardingReportType,
    IOnboardingReportWidget
> {
    private readonly fiOnboardingReportDataService = inject(FiOnboardingReportDataService);

    protected reportContainer: IOnboardingReportContainer = null;

    protected createCurrentReportWidget(): void {
        if (isNullOrUndefined(this.reportContainer)) {
            this.setReportData();
        } else {
            this.setCurrentReportWidgetData();
        }
    }

    private setReportData(): void {
        this.loading.set(true);
        this.fiOnboardingReportDataService.getReportContainer().then((reportContainer) => {
            this.reportContainer = reportContainer;
            this.setCurrentReportWidgetData();
            this.loading.set(false);
        });
    }

    private setCurrentReportWidgetData() {
        const newReportWidget: IOnboardingReportWidget = {
            Name: '',
            Description: '',
            ReportType: this.currentReportWidgetType,
            SortIndex: this.reportContainer.Widgets.length,
            Settings: {
                CurrentFilterGuid: '',
                Filters: [],
            },
        };
        this.reportWidget = { ...newReportWidget };
    }

    protected getCanCloseWithoutConfirmation(): boolean {
        return isNullOrUndefined(this.currentReportWidgetType);
    }
}
